import MenuAndScreens from '../../components/MenuAndScreens/MenuAndScreens'

export default function AppearanceLoginScreenPage() {
  return <MenuAndScreens />
}
